// extracted by mini-css-extract-plugin
export default {"sideNav":"styles_sideNav__Fz5yE","logo":"styles_logo__0r-su"};